module.exports = __webpack_public_path__ + "static/img/A61802_5.32a15b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61802_5.png
// module id = eoem
// module chunks = 1